import { useMemo } from "react";
import { useSDK } from "@contentful/react-apps-toolkit";
import { Sidebar } from ".";
import { Loading } from "../components";
import { TranslationContextProvider } from "../context";
import { State, defaultState } from "../context/types";
import { isGlossaryEnabled } from "../lib";
import { useFetchDeeplGlossary, useFetchDeeplLocales, useFetchDeeplUsage } from "../services";

export const SidebarWrapper = () => {
    const sdk = useSDK();

    const contentfulLocales = useMemo(() => {
        return Object.keys(sdk.locales.names)
            .map(key => ({
                locale: key,
                label: sdk.locales.names[key],
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [sdk.locales.names]);

    const {
        deeplSourceLocales,
        deeplTargetLocales,
        isDeeplSourceLocalesLoading,
        isDeeplTargetLocalesLoading,
    } = useFetchDeeplLocales();

    const { isLoading: isUsageLoading, data: usage, error: usageError } = useFetchDeeplUsage();

    const { data: glossary, isLoading: isGlossaryLoading } = useFetchDeeplGlossary(
        sdk.parameters.installation.glossaryId,
        { skip: !isGlossaryEnabled }
    );

    if (
        isDeeplSourceLocalesLoading ||
        isDeeplTargetLocalesLoading ||
        isUsageLoading ||
        isGlossaryLoading
    ) {
        return <Loading />;
    }

    if (!usage || usageError) {
        return null;
    }

    if (!deeplSourceLocales || !deeplTargetLocales) {
        return null;
    }

    const initialState: State = {
        ...defaultState,
        contentfulLocales,
        deeplSourceLocales,
        deeplTargetLocales,
        usage,
        formality: sdk.parameters.installation.formality ?? "default",
        glossary,
    };

    return (
        <TranslationContextProvider initialState={initialState}>
            <Sidebar />
        </TranslationContextProvider>
    );
};
